export default __webpack_public_path__ + "static/media/EM0440.34I-22012_-14997_0.cc37308b.jpg";